
/* eslint-disable */
import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import { getEventMouseOrTouchXY } from '@/utils/functions';
import {
  BoundingPosition,
  CoordinatesPosition,
  DesktopRoomObject,
  MessageHistory,
  Room,
  RoomObject,
} from '@/utils/models';
import MessageEditor from '@/components/room/users/MessageEditor.vue';
import { DataService } from '@/service/DataService';

@Component({ components: { MessageEditor } })
export default class MessageEditorDisplayer extends Vue {
  @Prop() room!: Room;
  @Prop() roomObject!: RoomObject | DesktopRoomObject;
  @Prop() dataService!: DataService;
  @Prop() messageHistories!: MessageHistory[];
  @Emit() private changePosition(arg: { newPosition: CoordinatesPosition; roomObject: RoomObject }) {}
  @Emit() closeAway() {}
  @Emit() messageSended() {}
  //#region 表示用プロパティ
  private moveStartPos: BoundingPosition = { x: 200, y: 200, width: 300, height: 355 };
  private moveStartMousePos: CoordinatesPosition = { x: 200, y: 200 };

  isMoving: boolean = false;
  mounted(): void {
    window.addEventListener('click', this.closeAwayHandler);
  }
  beforeDestroy() {
    window.removeEventListener('click', this.closeAwayHandler);
  }
  closeAwayHandler() {
    this.closeAway();
  }
  private onChangePosition(newPosition: CoordinatesPosition) {
    this.changePosition({ newPosition, roomObject: this.roomObject });
  }

  //#region 移動処理
  onPointerDownHandler(e: PointerEvent) {
    const el = e.currentTarget as HTMLElement;
    e.stopPropagation();
    el.addEventListener('pointermove', this.onMouseMoveHandler);
    el.setPointerCapture(e.pointerId);
    this.moveStartPos = {
      x: this.roomObject.position.x,
      y: this.roomObject.position.y,
      width: this.roomObject.width,
      height: this.roomObject.size,
    };
    const pointerPosition: CoordinatesPosition = getEventMouseOrTouchXY(e);
    this.moveStartMousePos = pointerPosition;
  }
  private onMouseMoveHandler(e: PointerEvent | TouchEvent) {
    if (!e) {
      return;
    }
    e.preventDefault();
    e.stopPropagation();
    const pointerPosition: CoordinatesPosition = getEventMouseOrTouchXY(e);
    const diff: CoordinatesPosition = {
      x: pointerPosition.x - this.moveStartMousePos.x,
      y: pointerPosition.y - this.moveStartMousePos.y,
    };
    this.onMouseMoveMoveModeHandler(diff);
  }
  private onMouseMoveMoveModeHandler(diff: CoordinatesPosition) {
    const newPos: CoordinatesPosition = {
      x: this.moveStartPos.x + diff.x,
      y: this.moveStartPos.y + diff.y,
    };
    this.onChangePosition(this.updateBounding(newPos));
    this.isMoving = true;
  }
  private updateBounding(pos: CoordinatesPosition | BoundingPosition) {
    if (pos.x < 0) {
      pos.x = 0;
    }
    if (pos.y < 0) {
      pos.y = 0;
    }
    const width = Math.min(100, (pos as BoundingPosition)?.width ?? this.roomObject.width);
    const height = Math.min(100, (pos as BoundingPosition)?.height ?? this.roomObject.height);
    if (pos.x > this.room.roomSize.width - width) {
      pos.x = this.room.roomSize.width - width;
    }
    if (pos.y > this.room.roomSize.height - height) {
      pos.y = this.room.roomSize.height - height;
    }
    return pos;
  }
  onPointerUpHandler(e: PointerEvent) {
    e.stopPropagation();
    const el = e.currentTarget as HTMLElement;
    el.removeEventListener('pointermove', this.onMouseMoveHandler);
    el.releasePointerCapture(e.pointerId);
    this.isMoving = false;
  }
  //#endregion
}
